import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./ModuleChange.css";
import { toast } from "react-toastify";
import { AGGREGATE_BOOKING_LOADED } from "../../store/ActionTypes";
import { dispatcher } from "../../store/storeHelpers";
import moment from "moment";
import { getDailyContainerPlanningAB } from "../../services/tractorDataService";
import * as actionTypes from "../../store/ActionTypes";
import {
  tractorDataCreatorForStore,
  aggregateDataCreatorForStore,
  fiveMDataCreatorForStore,
} from "../../utils/dataFilter";
import { getAggregateDailyContainerPlanning } from "../../services/aggregateDataService";
import { getFiveMDailyContainerPlanning } from "../../services/fiveMDataService";
import { ChangeContainerDiversion } from "../../services/dataService";
import { TRACTOR_BOOKING_LOADED } from "../../store/ActionTypes";
import { FIVE_M_BOOKING_LOADED } from "../../store/ActionTypes";


function ModuleChangeModal({
  show,
  hide,
  dataType,
  showModal,
  date,
  setNoDataState,
  changeModuleData,
  button1,
  button2,
}) {
  const [showChangeProcessbutton1, setShowChangeProcessbutton1] = useState(button1);
  const [showChangeProcessbutton2, setShowChangeProcessbutton2] = useState(button2);
 
  async function ModuleChangeClickHandler(button) {
   
    if (button === "Aggregate" && dataType === "Tractor")
    { 

      
      var finalChangeData = [];
      if (changeModuleData.length > 0) {
        for (let i = 0; i < changeModuleData.length; i++) {
          if(changeModuleData[i].IsFactoryOut === 0 && changeModuleData[i].Booking_Number !== null )
          {
         
          finalChangeData.push({
            DailyContainerPlanningId:
              changeModuleData[i].DailyContainerPlanningId,
            Booking_Number: changeModuleData[i].Booking_Number,
            AssignContainerId: changeModuleData[i].AssignContainerId,
            type: dataType,
            DivertedTo: "Aggregate",
          });
        }
        }
      }
      try {
        await ChangeContainerDiversion(finalChangeData);
        setShowChangeProcessbutton1("Updating...")
        const response = await getDailyContainerPlanningAB(
          moment(date).format("YYYY-MM-DD")
        );
        
        dispatcher(
          TRACTOR_BOOKING_LOADED,
          tractorDataCreatorForStore(response.data.Resultset1)
        );
       
        toast.success("Tractor data updated");
        setShowChangeProcessbutton1("Updating...")
       
        hide();
      } catch (error) {
        if (error.response.data.StatusCode === 404) {
          
         
          dispatcher(actionTypes.TRACTOR_BOOKING_LOADED, []);
          toast.success("Tractor data updated");
          setNoDataState(true);
          hide();

          
        } else {
          toast.error("something went wrong...please try again.");
          hide();
        
        }
      
      }

    }
   
    if (button === "5M" && dataType === "Tractor") {
      
      var finalChangeData = [];
      if (changeModuleData.length > 0) {
        for (let i = 0; i < changeModuleData.length; i++) {
          if(changeModuleData[i].IsFactoryOut === 0 && changeModuleData[i].Booking_Number !== null)
          {
          finalChangeData.push({
            DailyContainerPlanningId:
              changeModuleData[i].DailyContainerPlanningId,
            Booking_Number: changeModuleData[i].Booking_Number,
            AssignContainerId: changeModuleData[i].AssignContainerId,
            type: dataType,
            DivertedTo: "5M",
          });
        }
      }
      }

      try {
        await ChangeContainerDiversion(finalChangeData);
        setShowChangeProcessbutton2("Updating...")
        const response = await getDailyContainerPlanningAB(
          moment(date).format("YYYY-MM-DD")
        );
        dispatcher(
          TRACTOR_BOOKING_LOADED,
          tractorDataCreatorForStore(response.data.Resultset1)
        );
        toast.success("Tractor data updated");
        hide();
      } catch (error) {
        if (error.response.data.StatusCode === 404) {
          
         
          dispatcher(actionTypes.TRACTOR_BOOKING_LOADED, []);
          toast.success("Tractor data updated");
          setNoDataState(true);
          hide();

          
        } else {
          toast.error("something went wrong...please try again.");
          hide();
        
        }
      }
    }
    if (button === "Tractor" && dataType === "Aggregate" )
    { 
     
      var finalChangeData = [];
      if (changeModuleData.length > 0) {
        for (let i = 0; i < changeModuleData.length; i++) {
          if(changeModuleData[i].IsFactoryOut === 0 && changeModuleData[i].Booking_Number !== null)
          {
          finalChangeData.push({
            DailyContainerPlanningId:
              changeModuleData[i].DailyContainerPlanningAggregateId,
            Booking_Number: changeModuleData[i].Booking_Number,
            AssignContainerId: changeModuleData[i].AssignContainerAggregateId,
            type: dataType,
            DivertedTo: "Tractor",
          });
        }
      }
      }
      try {
        await ChangeContainerDiversion(finalChangeData);
        setShowChangeProcessbutton1("Updating...")
        const response = await getAggregateDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
        dispatcher(
          AGGREGATE_BOOKING_LOADED,
          aggregateDataCreatorForStore(response.data.Resultset1)
        );
        setShowChangeProcessbutton1("Updating...")
        toast.success("Aggregate data updated");
        hide();
      } catch (error) {
        if (error.response.data.StatusCode === 404) {
          
         
          dispatcher(actionTypes.AGGREGATE_BOOKING_LOADED, []);
          toast.success("Aggregate data updated");
          setNoDataState(true);
          hide();

          
        } else {
          toast.error("something went wrong...please try again.");
          hide();
        
        }
      }

    }
    if (button === "5M" && dataType === "Aggregate" ) {
      
      var finalChangeData = [];
      if (changeModuleData.length > 0) {
        for (let i = 0; i < changeModuleData.length; i++) {
          if(changeModuleData[i].IsFactoryOut === 0 && changeModuleData[i].Booking_Number !== null)
          {
          finalChangeData.push({
            DailyContainerPlanningId:
              changeModuleData[i].DailyContainerPlanningAggregateId,
            Booking_Number: changeModuleData[i].Booking_Number,
            AssignContainerId: changeModuleData[i].AssignContainerAggregateId,
            type: dataType,
            DivertedTo: "5M",
          });
        }
      }
      }

      try {
        await ChangeContainerDiversion(finalChangeData);
        setShowChangeProcessbutton2("Updating...")
        const response = await getAggregateDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
        dispatcher(
          AGGREGATE_BOOKING_LOADED,
          aggregateDataCreatorForStore(response.data.Resultset1)
        );
        toast.success("Aggregate data updated");
        hide();
      } catch (error) {
        if (error.response.data.StatusCode === 404) {
          
         
          dispatcher(actionTypes.AGGREGATE_BOOKING_LOADED, []);
          toast.success("Aggregate data updated");
          setNoDataState(true);
          hide();

          
        } else {
          toast.error("something went wrong...please try again.");
          hide();
        
        }
      }
    }
    if (button === "Tractor" && dataType === "5M") {
      
      var finalChangeData = [];
      if (changeModuleData.length > 0) {
        for (let i = 0; i < changeModuleData.length; i++) {
          if(changeModuleData[i].IsFactoryOut === 0 && changeModuleData[i].Booking_Number !== null)
          {
          finalChangeData.push({
            DailyContainerPlanningId:
              changeModuleData[i].DailyContainerPlanning5MId,
            Booking_Number: changeModuleData[i].Booking_Number,
            AssignContainerId: changeModuleData[i].AssignContainer5MId,
            type: dataType,
            DivertedTo: "Tractor",
          });
        }
      }
      }
     

      try {
        await ChangeContainerDiversion(finalChangeData);
        setShowChangeProcessbutton1("Updating...")
        const response = await getFiveMDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
      	dispatcher(
          FIVE_M_BOOKING_LOADED,
          fiveMDataCreatorForStore(response.data.Resultset1)
        );
        toast.success("5M data updated");
        hide();
      } catch (error) {
        if (error.response.data.StatusCode === 404) {
          
         
          dispatcher(actionTypes.FIVE_M_BOOKING_LOADED, []);
          toast.success("5M data updated");
          setNoDataState(true);
          hide();

          
        } else {
          toast.error("something went wrong...please try again.");
          hide();
        
        }
      }
    }
    if (button === "Aggregate" && dataType === "5M") {
      
      var finalChangeData = [];
      if (changeModuleData.length > 0) {
        for (let i = 0; i < changeModuleData.length; i++) {
          if(changeModuleData[i].IsFactoryOut === 0 && changeModuleData[i].Booking_Number !== null)
          {
          finalChangeData.push({
            DailyContainerPlanningId:
              changeModuleData[i].DailyContainerPlanning5MId,
            Booking_Number: changeModuleData[i].Booking_Number,
            AssignContainerId: changeModuleData[i].AssignContainer5MId,
            type: dataType,
            DivertedTo: "Aggregate",
          });
        }
      }
      }
     

      try {
        await ChangeContainerDiversion(finalChangeData);
        setShowChangeProcessbutton2("Updating...")
        const response = await getFiveMDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
      	dispatcher(
          FIVE_M_BOOKING_LOADED,
          fiveMDataCreatorForStore(response.data.Resultset1)
        );
        toast.success("5M data updated");
        hide();
      } catch (error) {
        if (error.response.data.StatusCode === 404) {
          
         
          dispatcher(actionTypes.FIVE_M_BOOKING_LOADED, []);
          toast.success("5M data updated");
          setNoDataState(true);
          hide();

          
        } else {
          toast.error("something went wrong...please try again.");
          hide();
        
        }
      }
    }
  }
  

  return (
    <>
      <Modal
        show={show || showModal.status}
        centered
        className="ChangeModal"
        dialogClassName="deleteWidthClass"
        contentClassName="deleteHeightClass"
      >
        <Modal.Body>
          
        <button className="moduleChange__closeBtn" onClick={hide}>
                <i class="bx bxs-x-square"></i>
              </button>
          
           
    
          <div className="ChangeModal__container">
            <div className="ChangeModal__title">confirm</div>
            

            <div className="ChangeModal__description">
            {showModal.msg}
            </div>
            <div className="ChangeModal__Btn">
              <Button
                className="ChangeModal__noBtn"
                onClick={() => {ModuleChangeClickHandler(button1)} }
                 disabled={showChangeProcessbutton1 === "Updating..."}
              
              >
                
                {showChangeProcessbutton1}
              </Button>
              <Button
                className="ChangeModal__yesBtn"
                onClick={() => {ModuleChangeClickHandler(button2)} }
                disabled={showChangeProcessbutton2 === "Updating..."}
              >
                
                {showChangeProcessbutton2}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ModuleChangeModal;
